module.exports = __webpack_public_path__ + "01_very_short_brown.c5778a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_very_short_brown.png
// module id = wTEL
// module chunks = 0